import React from "react";

import WPButton from "../../packages/WPButton";

const PlantsCountRenderer = (props) => {
  const plantCount = props?.data?.plant_count ?? props?.value ?? 0;
  const isShowPlantsDisabled = Number(plantCount) <= 0;

  const invokeParentMethod = () => {
    if (isShowPlantsDisabled) return;
    // Set a global flag so AgTable rowClickHandler ignores this click.
    window.isTableCellAction = true;
    if (props.context && props.context.handleShowPlants) {
      props.context.handleShowPlants({ data: props.node.data });
    }
    setTimeout(() => {
      window.isTableCellAction = false;
    }, 0);
  };

  return (
    <div
      style={{
        margin: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 8,
      }}
    >
      <span style={{ minWidth: 30 }}>{plantCount}</span>
      <WPButton disabled={isShowPlantsDisabled} onClick={invokeParentMethod}>
        Show Plants
      </WPButton>
    </div>
  );
};

export default PlantsCountRenderer;
